/*

Yogeshsrigiri 09/29/2022 3225736869 implemented breadcrumbs for all the side menu pages
Lalitha 10/27/2022 3225736869 night jobs UX changes
Raghu 27/10/2022 3225736869 dashboard alignment fixes
ashraf 10/30/2022 3225736869 conditional tabs render
Rajesh 11/14/2022 3225736869 Add night jobs New UX.
Suresh Peddavoora 12/05/2022 3225736869 Modified Landing Page Format.
Ashraf 12/05/2022 3225736869 Fixed header labels

*/

import React from 'react';
import {useSelector} from 'react-redux';
import Tabs from './Tabs';
import {ErrorSnackbar, SuccessSnackbar} from '../../../components/CustomSnackBar';
import LandingPage from '../../../Pages/LandingPage';

function NightJob() {
  const [value, setValue] = React.useState(0);
  const {successMsg, errorMsg} = useSelector(({addNightJob}) => addNightJob);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <>
      <LandingPage title={'Scheduler'} showTabs={true} tabValue={value} handleTabChange={handleChange} allAntTabs={[]}>
        <div className={`global-field-dash-board`}>
          <Tabs value={value} setValue={setValue}/>
          {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
          {successMsg && <SuccessSnackbar successMsg={successMsg} />}
        </div>
      </LandingPage>
    </>
  );
}

export default NightJob;
